/*
 * Copyright © 2020-2023 Ocean Galaxy Inc. All Rights Reserved.
 * @Description:
 * @LastEditors: jiakaiwen jiakaiwen@huihaiyinhe.com
 * @LastEditTime: 2026-01-23 11:35:59
 */
import React, { useMemo, useCallback, useEffect, useState, useRef } from 'react'
import { Divider } from 'antd'
import { useAppDispatch, useAppSelector } from '../../../app/hooks'
import sensors, { sensorsRole } from '../../../utils/sensors'
import CONFIG from '../../../constants/config'
import { formatStorageSize } from '../../../utils/utils'
import dayjs from 'dayjs'

const HeaderStatistics = () => {
  const dispatch = useAppDispatch()
  const myRole = useAppSelector((state) => state.group.myRole)
  const viewPerm = useAppSelector((state) => state.group.viewPerm)
  const groupID = useAppSelector((state) => state.group.groupId)
  const statistics = useAppSelector((state) => state.group.statistics)
  const isStatisticsTracked = useRef(false)

  const photosLabel = useMemo(() => {
    if (myRole > CONFIG.memberRoleTypes.NORMAL) {
      return '团队照片'
    } else if (viewPerm === CONFIG.viewPermissionTypes.GROUP) {
      return '团队照片'
    } else if (viewPerm === CONFIG.viewPermissionTypes.PERSONAL) {
      return '个人照片'
    } else if (viewPerm === CONFIG.viewPermissionTypes.DEPARTMENT) {
      return '部门照片'
    }
  }, [myRole, viewPerm])

  const fileSize = useMemo(() => {
    return formatStorageSize(statistics?.filesize)
  }, [statistics])

  const photoNum = useMemo(() => {
    if (statistics) {
      return {
        totalNum:
          statistics?.totalNum < 10000
            ? statistics?.totalNum
            : (statistics?.totalNum / 10000).toFixed(1),
        unit: statistics?.totalNum < 10000 ? '张' : '万张'
      }
    }
    return null
  }, [statistics])

  const memberCount = useMemo(() => {
    if (statistics) {
      return {
        memberCount:
          statistics?.memberCount < 10000
            ? statistics?.memberCount
            : (statistics?.memberCount / 10000).toFixed(1),
        unit: statistics?.memberCount < 10000 ? '人' : '万人'
      }
    }
    return null
  }, [statistics])

  const serverDuration = useMemo(() => {
    if (statistics) {
      const duration = dayjs.duration(statistics?.groupTime, 'seconds')
      return {
        serverDuration:
          duration.asDays() < 365
            ? Math.round(duration.asDays())
            : duration.asYears().toFixed(1),
        unit: duration.asDays() < 365 ? '天' : '年'
      }
    }
    return null
  }, [statistics])

  const savedMoney = useMemo(() => {
    if (statistics) {
      const days = dayjs.duration(statistics?.groupTime, 'seconds').asDays()
      const money = statistics.memberCount * days * 0.8
      return {
        savedMoney:
          money < 10000
            ? money < 500
              ? 500
              : Math.round(money)
            : (money / 10000).toFixed(2),
        unit: money < 10000 ? '元' : '万元'
      }
    }
    return null
  }, [statistics])

  useEffect(() => {
    if (!groupID) return
  }, [groupID])

  useEffect(() => {
    //等统计信息和团队信息都获取到了再上报

    if (statistics && myRole > -1 && !isStatisticsTracked.current) {
      const stat = statistics.data ? statistics.data : statistics
      const dayUsed = Math.round(
        dayjs.duration(stat.groupTime, 'seconds').asDays()
      )
      const money = Math.round(stat.memberCount * dayUsed * 0.8)
      sensors.track('web_workgroup_album_summary', {
        totalNum: stat.totalNum,
        fileSize: Math.round(stat.filesize / 1024 / 1024),
        memberNum: stat.memberCount,
        dayUsed: dayUsed,
        costSaving: money,
        role: sensorsRole(myRole)
      })
      isStatisticsTracked.current = true
    }
  }, [statistics, myRole])

  return (
    <div className="header-statistics">
      <div className="statistics-item" style={{ width: '72px' }}>
        <p className="label">{photosLabel}</p>
        <p className="value">
          {photoNum ? (
            <>
              <span>{photoNum.totalNum}</span>
              {photoNum.unit}
            </>
          ) : (
            '· · ·'
          )}
        </p>
      </div>
      <Divider
        orientation="vertical"
        style={{
          margin: 0,
          height: '34px',
          background: 'rgba(255,255,255, 0.2)'
        }}
      />
      <div className="statistics-item" style={{ width: '72px' }}>
        <p className="label">使用空间</p>
        <p className="value">
          {statistics ? (
            <>
              <span>{fileSize.size}</span>
              {fileSize.unit}
            </>
          ) : (
            '· · ·'
          )}
        </p>
      </div>
      <Divider
        orientation="vertical"
        style={{
          margin: 0,
          height: '34px',
          background: 'rgba(255,255,255, 0.2)'
        }}
      />
      <div className="statistics-item" style={{ width: '60px' }}>
        <p className="label">成员数</p>
        <p className="value">
          {memberCount ? (
            <>
              <span>{memberCount.memberCount}</span>
              {memberCount.unit}
            </>
          ) : (
            '· · ·'
          )}
        </p>
      </div>
      <Divider
        orientation="vertical"
        style={{
          margin: 0,
          height: '34px',
          background: 'rgba(255,255,255, 0.2)'
        }}
      />
      <div className="statistics-item" style={{ width: '72px' }}>
        <p className="label">服务时长</p>
        <p className="value">
          {serverDuration ? (
            <>
              <span>{serverDuration.serverDuration}</span>
              {serverDuration.unit}
            </>
          ) : (
            '· · ·'
          )}
        </p>
      </div>
      <div
        className="statistics-item"
        style={{
          // width: '67px',
          width: 'auto',
          padding: '0 12px',
          background: '#584b35',
          borderRadius: '0 2px 2px 0'
        }}
      >
        <p className="label" style={{ color: '#FFC86A' }}>
          已节省
        </p>
        <p className="value" style={{ color: '#FFE8C0' }}>
          {savedMoney ? (
            <>
              <span className="saved-money">{savedMoney.savedMoney}</span>
              {savedMoney.unit}
            </>
          ) : (
            '· · ·'
          )}
        </p>
      </div>
    </div>
  )
}

export default HeaderStatistics
